import type { DbSection } from '@domain/schemas/contract.schema';

import { isSummarySection } from './is-summary-section';

export const hasSummarySections = (sections: Pick<DbSection, 'sk'>[]): boolean => sections.some(isSummarySection);
